/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

export default class SearchHostContext {
	static hostContext: HostContext;

	static setContext(hostContext: HostContext): void {
		SearchHostContext.hostContext = hostContext;
	}

	static getContext(): HostContext {
		return SearchHostContext.hostContext;
	}

	static hasFeature(featureFlag: string): boolean {
		return SearchHostContext.getContext() && SearchHostContext.getContext().featureFlags.includes(featureFlag);
	}

	static isAuthenticated(): boolean {
		const authenticatedKeyExist = 'authenticated' in SearchHostContext.hostContext.imsInfo;
		if (authenticatedKeyExist) {
			return SearchHostContext.hostContext.imsInfo.authenticated;
		}
		// this case is for surfaces that haven't updated their hostContext with this field.
		// TODO : remove when all surfaces have implmented this.
		return true;
	}

	/**
	 * Add features to host context
	 * Make sure they are not duplicated
	 * @param newFeatureFlags
	 */
	static addFeatures(newFeatureFlags: Array<string>): void {
		SearchHostContext.getContext().featureFlags = [
			...new Set(SearchHostContext.getContext().featureFlags.concat(newFeatureFlags)),
		];
	}

	static getOptOutAnalytics(): boolean {
		const hostContext = SearchHostContext.getContext();
		const clientData =
			typeof hostContext.analyticsDataFunction === 'function' ? hostContext.analyticsDataFunction() : {};
		const analyticData = clientData?.analyticData;
		return typeof analyticData.optOutAnalytics === 'boolean' ? analyticData.optOutAnalytics : true;
	}
}
